// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__aIyMI","content":"Spinner_content__3isIA","spinner":"Spinner_spinner__Z6H3E","lds-ring":"Spinner_lds-ring__8iBUL"};